import { useEffect, useState } from "react";

const DEFAULT_DELAY_IN_MS = 500;
const DEFAULT_HIDE_DELAY_IN_MS = 200;

export const useSpinDelay = (
  isLoading: boolean,
  { delay = DEFAULT_DELAY_IN_MS, hideDelay = DEFAULT_HIDE_DELAY_IN_MS } = {}
) => {
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);

  useEffect(() => {
    if (isLoading === isSpinnerVisible) return;
    const timeout = setTimeout(() => setIsSpinnerVisible(isLoading), isLoading ? delay : hideDelay);
    return () => clearTimeout(timeout);
  }, [isLoading, isSpinnerVisible, delay, hideDelay]);

  return isSpinnerVisible;
};
